import { createRootRoute, createRoute } from '@tanstack/react-router';

import { PatientAccountPage } from '@/pages/account/PatientAccountPage';
import { DexcomCallback } from '@/pages/add-measurement/DexcomCallback';
import { MeasurementImportPage } from '@/pages/add-measurement/MeasurementImportPage';
import { PatientLayout } from '@/pages/layout/PatientLayout';

const patientRootRoute = createRootRoute({
  component: PatientLayout,
});

export const patientRoutes = {
  measurementImport: createRoute({
    getParentRoute: () => patientRootRoute,
    path: '/',
    component: MeasurementImportPage,
  }),
  account: createRoute({
    getParentRoute: () => patientRootRoute,
    path: 'account',
    component: PatientAccountPage,
  }),
  dexcomCallback: createRoute({
    getParentRoute: () => patientRootRoute,
    path: 'dexcom/callback',
    component: DexcomCallback,
  }),
};

export const patientRouteTree = patientRootRoute.addChildren([
  patientRoutes.measurementImport,
  patientRoutes.account,
  patientRoutes.dexcomCallback,
]);
